import { render, staticRenderFns } from "./gru.vue?vue&type=template&id=2e14410c&"
import script from "./gru.vue?vue&type=script&lang=js&"
export * from "./gru.vue?vue&type=script&lang=js&"
import style0 from "./gru.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports